export type SearchEntityType = 'navigation' | 'contact' | 'company' | 'deal' | 'task' | 'ticket';

export interface SearchResult {
  type: SearchEntityType;
  id: number;
  title: string;
  subtitle?: string;
  routerLink: string;
  iconKey?: string;        // ← NUEVO
}

export interface SearchResults {
  navigation: SearchResult[];   // ← NUEVO
  contacts: SearchResult[];
  companies: SearchResult[];
  deals: SearchResult[];
  tasks: SearchResult[];
  tickets: SearchResult[];
  totalCount: number;
  isLoading: boolean;
}

export const EMPTY_SEARCH_RESULTS: SearchResults = {
  navigation: [],   // ← NUEVO
  contacts: [],
  companies: [],
  deals: [],
  tasks: [],
  tickets: [],
  totalCount: 0,
  isLoading: false
};
